import styled from 'styled-components';
import { COLOR_WHITE } from '../constants';

const Div = styled.div`
  ${p => p.center && 'text-align: center'};
  ${p => p.rounded && 'border-radius: 4px'};
  ${p => p.padding && `padding: ${p.padding}`};
  ${p => p.margin && `margin: ${p.margin}`};
  box-shadow: 0px 2px 16px 0px rgba(43, 85, 162, 0.11);
  background-color: ${COLOR_WHITE};
`;

export default Div;
